/* eslint-disable no-useless-escape */
import { STRING_PATTERNS } from '../../shared/constants';
import {
  CONTENTFUL_INPUT_TYPES,
  FORM_CONTEXT_TYPES,
} from '../../shared/constants/Contentful.constants';

export const formStringRegex = (inputType: string, contextType?: string) => {
  if (!contextType) {
    if (inputType === CONTENTFUL_INPUT_TYPES.text) {
      return STRING_PATTERNS.text;
    }
    if (inputType === CONTENTFUL_INPUT_TYPES.email) {
      return STRING_PATTERNS.email;
    }
    if (inputType === CONTENTFUL_INPUT_TYPES.tel) {
      return STRING_PATTERNS.tel;
    }
    if (inputType === CONTENTFUL_INPUT_TYPES.url) {
      return STRING_PATTERNS.url;
    }
    if (inputType === CONTENTFUL_INPUT_TYPES.number) {
      return STRING_PATTERNS.number;
    }
  }
  if (contextType && inputType === CONTENTFUL_INPUT_TYPES.text) {
    if (contextType === FORM_CONTEXT_TYPES.kvkNumber) {
      return STRING_PATTERNS.kvkNumber;
    }
    if (contextType === FORM_CONTEXT_TYPES.currency) {
      return STRING_PATTERNS.currency;
    }
    if (contextType === FORM_CONTEXT_TYPES.specialCharacters) {
      return STRING_PATTERNS.specialCharacters;
    }
    if (contextType === FORM_CONTEXT_TYPES.postalCode) {
      return STRING_PATTERNS.postalCode;
    }
    if (contextType === FORM_CONTEXT_TYPES.numbersLettersOnly) {
      return STRING_PATTERNS.numbersLettersOnly;
    }
    if (contextType === FORM_CONTEXT_TYPES.accountNumber) {
      return STRING_PATTERNS.accountNumber;
    }
  }
  return STRING_PATTERNS.default;
};

export const matchRegex = (copyToValidate: string, regexToMatch: RegExp) => {
  const regex = new RegExp(regexToMatch);

  if (regex.exec(copyToValidate) !== null) {
    return {
      customPatternMismatch: false,
    };
  }
  return {
    customPatternMismatch: true,
  };
};
